export const centerTextWrapperStyle = {
  backgroundColor: 'custom.opaqueBlue',
  boxShadow: '2px 5px 10px black',
  borderRadius: '10px',
  mt: 12,
  p: 4,
  width: 'fit-content',
};

export const bottomTextWrapperStyle = {
  backgroundColor: 'custom.opaqueBlue',
  boxShadow: '2px 5px 10px black',
  borderRadius: '10px',
  mt: 12,
  p: 4,
  width: 'fit-content',
  alignSelf: 'flex-end',
};
